import query from 'query-string';

import { Queries } from 'components/overlays/context/types';

export const createQuery = (queries = {}) => {
  return `?${query.stringify(queries)}`;
};

export const parseQuery = <T = Record<string, string>>(search = ''): T => {
  return query.parse(search) as T;
};

export const mergeQuery = (search = '', queries = {}) => {
  const query = parseQuery(search);
  return createQuery({ ...query, ...queries });
};

export const replaceQuery = (queries = {}) => {
  return createQuery(queries);
};

export const parseArray = (value: unknown): string[] => {
  if (!value) return [];
  if (Array.isArray(value)) return value.map(String);
  if (typeof value === 'string') return value.split(',').map(String);
  return [];
};

export const resetQueries = (queries: Queries): Queries => {
  return Object.entries(queries).reduce((acc, [key, value]) => {
    acc[key] = Array.isArray(value) ? [] : '';
    return acc;
  }, {} as Queries);
};
